class ManagerModel {
  id = null;
  constructor(managerData) {
    let { id } = managerData;
    this.id = id;
  }
}

export default ManagerModel;
